import { ApiCarData } from '@interfaces/car-api.types';
import { FilterState } from '@interfaces/filter.types';
import { 
  ApiFilterParams, 
  transformFiltersToApiParams, 
  buildQueryString 
} from '@utils/filterTransformUtils';
import { SEARCH_CARS_URL } from './endpoints';

export type { ApiFilterParams };

export const carListingService = {
  getCarList: async (offset = 0, limit = 24, cityName: string, filters?: ApiFilterParams, userId?: string, source?: string): Promise<{ cars: ApiCarData[]; totalCount: number | null; pageCount?: number} | null> => {
    try {
      const page = Math.floor(offset / limit) + 1;
      const size = limit;

      const baseParams: Record<string, string | number> = {
        city: cityName,
        size: size.toString(),
        page: page.toString()
      };

      if (source) {
        baseParams.source = source;
      }

      const queryString = filters
        ? buildQueryString(filters, baseParams)
        : buildQueryString({}, baseParams);

      const response = await fetch(`${SEARCH_CARS_URL}?${queryString}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-user-id' : userId || ''
        },
      });

      const data = await response.json();
      const totalCount = data.total_count ?? null;
      const pageCount = data.total_pages;
      return { cars: data.result, totalCount, pageCount };

    } catch (error: any) {
      console.error('Error fetching car list:', error?.message);
      return null;
    }
  },

  transformFilters: (filters: FilterState, filterOptions: any): ApiFilterParams => {
    return transformFiltersToApiParams(filters, filterOptions);
  }
};